export default function getCustomTokenFromLocalStorage() {
    return localStorage.getItem("customToken");
  }
  